import React from 'react';
import loginBg from '../assets/login_bg.png';
import ResetPassword from '../components/ResetPassword';
import '../css/Login.css';

const ResetPasswordPage = () => {
  return (
    <div className="login-container">
      <div className="login-split-bg">
        <div className="login-panel login-panel-image">
          <img src={loginBg} alt="Reset Password" />
          <div className="login-panel-caption">
            <h3>Jelszó visszaállítás</h3>
            <p>Add meg az új jelszavadat a folytatáshoz.</p>
          </div>
        </div>
        <div className="login-panel login-panel-form">
          <ResetPassword />
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
